import React, { useState } from 'react';
import "./TableHeader.scss"
import AddRecord from '../../Record/AddRecord/AddRecord';
import ClinicsSelector from '../../Clinics/ClinicsSelector/ClinicsSelector';
import PeriodSelector from '../../UI/PeriodSelector/PeriodSelector';
import RecordSearch from '../RecordSearch/RecordSearch';
import ServicesSettings from '../../Services/ServicesSettings/ServicesSettings';
import Notifications from '../../Notifications/Notifications/Notifications';

const TableHeader = () => {
	return (
		<div className="table-header">
			<div className="app-container">
				<div className="table-header__inner">
					<div className="table-header__add">
						<AddRecord/>
					</div>
					<div className="table-header__clinics">
						<ClinicsSelector/>
					</div>
					<div className="table-header__period">
						<PeriodSelector/>
					</div>
					<div className="table-header__search">
						<RecordSearch/>
					</div>
					<div className="table-header__sidebar">
						<ServicesSettings/>
						<Notifications/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TableHeader;
